// See https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/.
export function downloadBlob(blob: Blob, filename: string) {
  // Create an object URL for the blob object
  const url = URL.createObjectURL(blob);

  // Create a new anchor element
  const a = document.createElement('a');

  // Set the href and download attributes for the anchor element
  a.href = url;
  a.download = filename || 'download';

  // Click handler that releases the object URL after the element has been clicked
  // This is required for one-off downloads of the blob content
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };

  // Add the click event listener on the anchor element
  // Comment out this line if you don't want a one-off download of the blob content
  a.addEventListener('click', clickHandler, false);

  // Programmatically trigger a click on the anchor element
  // Useful if you want the download to happen automatically
  // Without attaching the anchor element to the DOM
  // Comment out this line if you don't want an automatic download of the blob content
  a.click();

  // Return the anchor element
  // Useful if you want a reference to the element
  // in order to attach it to the DOM or use it in some other way
  return a;
}

export function createCsvBlob(csvContent: string) {
  // add UTF-8 header for file encoding
  return new Blob(['\ufeff', csvContent], { type: 'text/csv' });
}

/**
 *  Function that receives the size of a file in Bytes and converts it, if needed, to KB if above 1024 Bytes and to
 *  MB if above 1024 KB with a 2 digits precision and returns the result as a display string
 *  @param size
 *  @returns string
 *
 */
export function fileSizeConvertor(size: number): string {
  let fileSize: string = size + ' B';
  if (Math.floor(size / 1024)) {
    fileSize = (size / 1024).toFixed(2) + ' KB';
  }
  if (Math.floor(size / 1024 / 1024)) {
    fileSize = (size / 1024 / 1024).toFixed(2) + ' MB';
  }
  return fileSize
}
